import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

export default function DashboardAlertBanner({ title, description, href, hrefLabel, tone = "amber", testId }) {
  const tones = {
    amber: "border-bansal-gold bg-amber-50 dark:bg-amber-950/30 text-amber-950 dark:text-amber-100",
    teal: "border-teal-600 bg-teal-50 dark:bg-teal-950/30 text-teal-950 dark:text-teal-100",
    rose: "border-rose-400 bg-rose-50 dark:bg-rose-950/30 text-rose-950 dark:text-rose-100",
  };
  return (
    <div
      className={`border-l-4 rounded-r-xl px-4 py-3 flex flex-col sm:flex-row sm:items-center gap-3 ${tones[tone] || tones.amber}`}
      data-testid={testId}
    >
      <div className="flex items-start gap-3 min-w-0 flex-1">
        <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 opacity-80" />
        <div className="min-w-0">
          <div className="font-medium text-sm">{title}</div>
          {description ? <p className="text-xs opacity-90 mt-0.5">{description}</p> : null}
        </div>
      </div>
      {href ? (
        <Link
          to={href}
          className="shrink-0 text-center px-3 py-2 text-xs uppercase tracking-widest rounded-md border border-current/30 hover:bg-black/5 dark:hover:bg-white/5 min-h-10 inline-flex items-center justify-center"
        >
          {hrefLabel || "Open"}
        </Link>
      ) : null}
    </div>
  );
}
